import { useEffect, useState } from 'react';
import {
  ConfigurationNotCompleteReasonsDropdown,
  NudosTextArea,
  NudosUploadDownloadButton
} from '../../../../NudosComponents';
import {
  TProductConfigResponse,
  IconfigurationNotCompleteReason,
  CONFIGURATION_STATUS_MODAL_VALUES,
  LS_ADDITIONAL_SERVICE_NOT_COMPLETE_REASON_ID
} from '../../../../../types/product.configuration.types';
import { InotCompletedData } from '../ConfigurationStatusModalContent';
import { validateImageOrPdfCallback } from '../../../../../utils/validateFiles';
import { VISUAL_EVIDENCE_FILE_EXTENSIONS } from '../../../../../constants/constants';
import { getFileUrlsFromEvidence } from '../../../../../utils/configurations';

import './NotCompletedConfigurationFields.scss';

const NotCompletedConfigurationFields = ({
  type,
  initialData,
  updateDataCallback,
  configurationData,
  uploadProofFile
}: {
  type: CONFIGURATION_STATUS_MODAL_VALUES;
  initialData?: InotCompletedData;
  configurationData: TProductConfigResponse;
  updateDataCallback: React.Dispatch<React.SetStateAction<InotCompletedData | undefined>>;
  uploadProofFile: (file?: File) => void;
}) => {
  const [notCompleteReason, setNotCompleteReason] = useState<IconfigurationNotCompleteReason>();
  const [otherReasonComment, setOtherReasonComment] = useState<string>('');

  const { evidence } = configurationData;

  const imageUrls = getFileUrlsFromEvidence(evidence);
  const imageUrl = imageUrls?.find(ciUrl => VISUAL_EVIDENCE_FILE_EXTENSIONS.includes(ciUrl.split('.').pop() || ''));
  const isOtherReason = notCompleteReason?.id === LS_ADDITIONAL_SERVICE_NOT_COMPLETE_REASON_ID.OTHER;
  const currentFileUrl = type === CONFIGURATION_STATUS_MODAL_VALUES.SEE_NOT_COMPLETED_REASONS ? imageUrl : undefined;

  useEffect(() => {
    const newReasonId = notCompleteReason?.id || initialData?.logisticConfigurationNotCompletedReasonId;
    if (!newReasonId) return;
    const newData = {
      logisticConfigurationNotCompletedReasonId: newReasonId,
      otherReasonComment: otherReasonComment || initialData?.otherReasonComment
    };
    updateDataCallback(newData);
  }, [notCompleteReason?.name, otherReasonComment]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!otherReasonComment && initialData?.otherReasonComment)
      setOtherReasonComment(initialData.otherReasonComment || '');
  }, [initialData?.otherReasonComment]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className={`notCompletedConfigurationFields ${isOtherReason ? 'otherReason' : ''}`}>
      <ConfigurationNotCompleteReasonsDropdown
        currentValue={notCompleteReason}
        initialReasonId={initialData?.logisticConfigurationNotCompletedReasonId}
        clickSelectOptionCallback={setNotCompleteReason}
      />
      {isOtherReason && (
        <NudosTextArea
          label="Otras razones"
          placeholder="Describe las razones"
          currentValue={otherReasonComment || ''}
          maxLength={1000}
          setCurrentValue={setOtherReasonComment}
          componentSize="medium"
          textHeight={64}
          noResize
          hidenCounter
        />
      )}
      <NudosUploadDownloadButton
        customClassName="uploadProofButton notCompleteProof"
        customWidth="280px"
        uploadedFileHandler={uploadProofFile}
        downloadButtonText="Consultar evidencia"
        buttonEmptyText="PDF o JPG"
        buttonFilledText="PDF o JPG"
        showSkeletonLoader={false}
        keepOwnFileState
        currentFileUrl={currentFileUrl || undefined}
        validateFileCallback={validateImageOrPdfCallback}
      />
    </div>
  );
};

export default NotCompletedConfigurationFields;
